import config from '../config';

// Storage
export const storageLabels = {
    lang: 'ontime.AppLanguage'
  };
  export const ENGLISH = 'EN';
  export const SPANISH = 'ES';

  // Language
export const defaultLanguage = SPANISH.toLowerCase();

export const getAppLanguage = () => {
    const lang = sessionStorage.getItem(storageLabels.lang) || defaultLanguage;
  
    return lang.toLowerCase();
  };

export const setAppLanguage = (lang: string) => {
    sessionStorage.setItem(storageLabels.lang, lang.toLowerCase());
  };

export const getSupportedLanguageId = (language?: string) => {
  const normalizedLanguage = (language || defaultLanguage).toLowerCase().split('-')[0];

  if (normalizedLanguage === ENGLISH.toLowerCase()) {
    return ENGLISH.toLowerCase();
  }

  if (normalizedLanguage === SPANISH.toLowerCase()) {
    return SPANISH.toLowerCase();
  }

  return defaultLanguage;
};

export const getRidersTemplateUrl = (language?: string) =>
  `${config.ridersTemplateBaseUrl}/riders-${getSupportedLanguageId(language)}.xlsx`;